import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mdc-data',
  templateUrl: './mdc-data.component.html',
  styleUrls: ['./mdc-data.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class MdcDataComponent implements OnInit {
  @Input() mdcData:any;
  constructor() { }

  ngOnInit(): void {
  }

}
